import ObjectValues from "./ObjectValues"

const getOrdersTaxItems = order => {
  const taxes = {}

  order.items.forEach(item =>
    item.taxItems.forEach(taxItem => {
      taxes[taxItem.title] =
        !!taxes[taxItem.title]
          ?
          {
            title: taxItem.title,
            titleEn: taxItem.titleEn,
            titleAr: taxItem.titleAr,
            isNotTax: taxItem.isNotTax,
            percentage: taxItem.percent,
            constantValue: taxItem.constantValue,
            isPercentageModel: taxItem.isPercentageModel,
            amount: taxes[taxItem.title].amount + taxItem.amount
          }
          :
          {
            title: taxItem.title,
            titleEn: taxItem.titleEn,
            titleAr: taxItem.titleAr,
            isNotTax: taxItem.isNotTax,
            percentage: taxItem.percent,
            constantValue: taxItem.constantValue,
            isPercentageModel: taxItem.isPercentageModel,
            amount: taxItem.amount
          }
    })
  )

  return ObjectValues(taxes)
}

export default getOrdersTaxItems